import React from "react";
import { useTranslation } from "react-i18next";
import { Upload, Download, FileText, Loader2 } from "lucide-react";
import { Button } from "../ui/button";

const ImportUploadStep = ({ handleDownloadTemplate, handleFileSelect, isDetecting }) => {
  const { t } = useTranslation();

  return (
  <div className="space-y-6">
    <div className="bg-muted/30 border border-border rounded-lg p-4">
      <h4 className="font-semibold text-foreground mb-2 flex items-center">
        <FileText className="h-4 w-4 mr-2" />
        {t("importEmployees.upload.instructionsTitle")}
      </h4>
      <ol className="list-decimal list-inside space-y-1 text-sm text-muted-foreground">
        <li>{t("importEmployees.upload.stepDownload")}</li>
        <li>{t("importEmployees.upload.stepFill")}</li>
        <li>{t("importEmployees.upload.stepUpload")}</li>
        <li>{t("importEmployees.upload.stepConfirm")}</li>
      </ol>
    </div>

    <div className="flex justify-center">
      <Button onClick={handleDownloadTemplate} variant="outline" className="gap-2">
        <Download className="h-4 w-4" />
        {t("importEmployees.upload.downloadTemplate")}
      </Button>
    </div>

    <div className="border-2 border-dashed border-border rounded-lg p-8 text-center hover:border-blue-500 transition-colors">
      <input
        type="file"
        id="file-upload"
        className="hidden"
        accept=".csv,.xlsx,.xls"
        onChange={handleFileSelect}
        disabled={isDetecting}
      />
      <label htmlFor="file-upload" className="cursor-pointer">
        <div className="flex flex-col items-center space-y-3">
          {isDetecting ? (
            <Loader2 className="h-12 w-12 text-blue-500 animate-spin" />
          ) : (
            <Upload className="h-12 w-12 text-gray-400" />
          )}
          <div>
            <p className="text-lg font-medium text-muted-foreground">
              {isDetecting ? t("importEmployees.upload.detecting") : t("importEmployees.upload.selectFile")}
            </p>
            <p className="text-sm text-muted-foreground mt-1">
              {t("importEmployees.upload.acceptedFormats")}
            </p>
          </div>
        </div>
      </label>
    </div>
  </div>
  );
};

export default ImportUploadStep;
